export default theme => ({
  buttonBar: {
    marginTop: 20
  },
  locationButton: {
    width: 280,
    height: 36,
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.lightGrey2,
    color: theme.palette.textColor.headerLinkColor,
    '&:focus': {
      backgroundColor: theme.palette.background.lightGrey2,
    }
  },
  locationButtonImg: {
    marginRight: 4
  },
  menuList: {
    width: '100%',
    borderRadius: 6,
    padding: '1px 0',
  },
  selectedMenuItem: {
    backgroundColor: theme.palette.background.lightGrey2,
    color: theme.palette.textColor.headerLinkColor,
  }
})